import React from 'react';
import '../../tailwind.css';
import { IAppInfoContainer } from '../../types/AppInfoContainer.types';

const AppInfoContainer: React.FC<IAppInfoContainer> = (props) => {
  return (
    <div className="app-info pl-app-info-l pr-app-info-r">
      <div className="text-app-info-header font-bold leading-app-info-header tracking-app-info-header text-grey-90 mb-app-info-header">
        {props.title}
      </div>
      <div>
        {props.children}
      </div>
    </div>
  )
};

export default AppInfoContainer;
